import { GradientProgress } from '@components/gradient-progress'
import Box from '@mui/material/Box'

export const LazyPageLoading = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 1,
      height: 1,
    }}
  >
    <GradientProgress size={26} thickness={5} />
  </Box>
)
